import { SxProps, Theme } from '@mui/material';

/**
 * The height every card header stands at, matching Powód wizyty and Przebieg
 * wizyty on the visit page.
 */
export const CARD_HEADER_HEIGHT = 54;

/**
 * The header strip of a content card: its title, and whatever action belongs to
 * it — "Dodaj", "Edytuj profil pacjenta". Lay the two out as its direct
 * children; the row is part of the style.
 *
 * Matches the visit page's own cards (Powód wizyty, Przebieg wizyty, Notatki),
 * so a table card and a text card read as the same kind of thing. Shared
 * because each page builds its own header, which is how five of them drifted
 * onto three different paddings and surfaces.
 *
 * The top corners are rounded here rather than left to the card: these cards
 * round their corners but clip nothing, so a header with a background of its
 * own would otherwise square them off.
 */
export const CARD_HEADER_SX: SxProps<Theme> = {
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: 1,
  // Pinned rather than padded to a height: these headers hold a bare title on
  // one card and a title plus a button on the next, and a title is 24px tall
  // against a small button's 30px, so equal padding would give unequal cards.
  // The padding only matters once something taller than a button turns up.
  minHeight: CARD_HEADER_HEIGHT,
  paddingX: 2,
  paddingY: 1,
  backgroundColor: 'background.paper',
  borderTopLeftRadius: (theme) => theme.spacing(2),
  borderTopRightRadius: (theme) => theme.spacing(2),
};

/** The title inside {@link CARD_HEADER_SX}, matching those cards' titles. */
export const CARD_HEADER_TITLE_PROPS = {
  variant: 'body1' as const,
  fontWeight: 500,
};

export default CARD_HEADER_SX;
